import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { sort } from 'fast-sort';

import React from 'react';

import SyncMessage from "../../components/SyncMessage";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';

class AdkPartners extends React.Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            sortParam: null,
            sortOrder: 1,
            partners: [],
            partnerToUpdate: null,
            adk_partner_domains: [],
            syncData: null,
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.onUpdate = this.onUpdate.bind(this);

        this.handle_sync = this.handle_sync.bind(this);
    }

    componentDidMount() {
        this.loadPartners().catch(console.error);
    }

    componentWillUpdate(nextProps, nextState) {
        const { partners, sortParam, sortOrder } = nextState;

        if (this.state.sortParam !== sortParam || this.state.sortOrder !== sortOrder) {
            this.setState({
                partners: sort(partners)[sortOrder === 1 ? 'asc' : 'desc']((u) => u[sortParam])
            })
        }
    }

    async loadPartners() {
        this.setState({ isLoading: true });

        const [ partners, adk_partner_domains ] = await Promise.all([
            API.AdkPartners.get(),
            API.AdkPartnerDomains.get()
        ])

        this.setState({ isLoading: false, partners, adk_partner_domains });
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, partnerToUpdate: null });
    }

    handleFormSubmit(partner) {
        this.setState({
            partnerToUpdate: null,
            isShowForm: false,
            isLoading: true
        });

        console.log(partner)

        if (partner.id) {
            API.AdkPartners.update(partner.id, partner).then(() => this.loadPartners());
        } else {
            API.AdkPartners.save(partner).then(() => this.loadPartners());
        }
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.AdkPartners.remove(id).then(() => this.loadPartners());
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getForm() {
        if (this.state.isShowForm || this.state.partnerToUpdate) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                adk_partner_domains={this.state.adk_partner_domains}
                partner={this.state.partnerToUpdate}
            />;
        }
    }

    onUpdate(partner) {
        this.setState({ partnerToUpdate: partner })
    }

    async handle_sync() {
        if (!window.confirm(`Are you sure to perform sync?`)) return;

        this.setState({ loading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'partners')
            .then((res) => {
                this.setState({ loading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch((err) => {
                this.setState({ loading: false, syncData: { reqErr: err } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Partners"/>

                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <ButtonGroup>
                                <Button bsStyle="primary" onClick={this.handle_sync}>Sync</Button>

                                <Button bsStyle="success" onClick={this.handleAddBtnClick}>Add</Button>
                            </ButtonGroup>
                        </div>
                    </Col>
                </Row>

                <div style={{ width: '100%', marginTop: '5px' }}>
                    <SyncMessage {...this.state.syncData} />
                </div>

                {this.getForm()}

                <Table partners={this.state.partners} onUpdate={this.onUpdate} onRemove={this.handleRemoveBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default AdkPartners;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartners/index.js